import s from './HomeImage.module.css';
import mainScreenImage from '../../static/mainScreenImage.png';

const HomeImage = () => {
  return (
    <div className={s.rightScreen}>
      <img src={mainScreenImage} alt="" />
    </div>
  );
};

export { HomeImage };
